/**
 * This is a template for any order that fails, and it includes important details about that order
 * 
 * {
	"messageType": "alertNotification",
	"notificationId": 1645221320211,
	"notificationDetails": {"errorType":"ORDER_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ORDER_ERROR",
	"statusDetails": {"id":"1","symbol":"b","reason":"a","limitPrice":213.0,"quantity":12.0,"orderAction":"PLACE_ORDER","side":"BTO"},
	"date": "2022-02-18T16:55:20.830-0500",
	"timestamp": "1645221320832"
}

 * @param {*} statusDetails 
 * @returns an object with the following fields. any of these fields are game to be null
 * 1) id: id of the order
 * 2) symbol: symbol of the order
 * 3) reason: the reason the order failed (usually provided by the brokerage).
 * 4) side: BTO/STO/STC/BTC
 * 5) limitPrice: limit price of the order
 * 6) quantity: qty of the order
 * 7) orderAction: the action that was attempted (CANCEL_ORDER/PLACE_ORDER)
 */
export function orderErrorParser(statusDetails) {
  const parsedObj = {
    id: null,
    symbol: null,
    reason: null,
    side: null,
    limitPrice: null,
    quantity: null,
    orderAction: null,
  };
  if (statusDetails) {
    parsedObj.id = statusDetails.id ?? null;
    parsedObj.symbol = statusDetails.symbol ?? null;
    parsedObj.reason = statusDetails.reason ?? null;
    parsedObj.side = statusDetails.side ?? null;
    parsedObj.limitPrice = statusDetails.limitPrice ?? null;
    parsedObj.quantity = statusDetails.quantity ?? null;
    parsedObj.orderAction = statusDetails.orderAction ?? null;
  }

  return parsedObj;
}
